// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3JOpG","productName":"Table_productName__2Tv5Q"};